import { render } from "./DSidebarVersionInfo.vue?vue&type=template&id=e4c9ba60&scoped=true"
import script from "./DSidebarVersionInfo.vue?vue&type=script&lang=js"
export * from "./DSidebarVersionInfo.vue?vue&type=script&lang=js"

import "./DSidebarVersionInfo.vue?vue&type=style&index=0&id=e4c9ba60&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c9ba60"]])

export default __exports__